import {MadnesControls} from "./MadnesControls";
import {MadnesServer} from "./MadnesServer";
import {
    bet, madnes_add_win,
    madnes_circle_rand_inner_point,
    madnes_circle_rand_point,
    madnes_get_atomic_bet, madnes_get_money_bet,
    madnes_money_to_coin,
    madnes_rotate_start, madnes_set_win,
    madnes_set_win_factors,
    win
} from "../../../framework/src/engine/madnes/madnes";
import {
    wallet,
    big_win,
    he, inmoneyadd,
    mega_win,
    multi,
    picture_convert,
    super_win,
    wi, set_rotated, set_inanim, set_inmoneyadd, set_in_free_spins
} from "../../../framework/src/engine/madnes/madnes_variables";
import {madnes_generate_frame_names} from "../../../framework/src/engine/madnes/madnes_anims";
import {MadnesObject} from "./MadnesObject";
import {MadnesTimer} from "./MadnesTimer";
import {MadnesGroup} from "./MadnesGroup";
import MadnesTween from "./MadnesTween";
import {MadnesAudio} from "./MadnesAudio";
import {getRandomInt} from "../../../framework/src/helpers";
import {
    madnes_add_to_render,
    madnes_rem_from_render,
    madnes_shake_screen, madnes_shake_screenXY
} from "../../../framework/src/engine/madnes/madnes_render";
import {MadnesGraphics} from "./MadnesGraphics";

/**
 * @constructor
 * @returns {MadnesInterface}
 */
export function MadnesInterface() {
    /** @type {MadnesServer} */
    this.server;

    /** @type {MadnesControls} */
    this.controls;
};

MadnesInterface.prototype.init = function() {
    this.server = new MadnesServer();
    this.controls = new MadnesControls();
};

MadnesInterface.prototype.getTime = function() {
    return window.performance ? window.performance.now() : Date.now();
};

MadnesInterface.prototype.setState = function(state, val) {

    switch(state) {
        case "ROTATED":
            set_rotated(val);
            // rotated = val;
            break;
        case "INANIM":
            set_inanim(val);
            break;
    }
};

MadnesInterface.prototype.getState = function(state) {

    switch(state) {
        case "ROTATED":
            return rotated;
            break;
        case "INANIM":
            return inanim;
    }
};

MadnesInterface.prototype.isPortraitMode = function() {
    return madnes_is_portrait_mode();
};

MadnesInterface.prototype.isLastRoundAutostart = function() {
    return is_last_round_autostart();
};

MadnesInterface.prototype.setLastRoundAutostartEnabled = function(bool) {
    // last_round_autostart_enabled = bool;
};



/**
 * @param {number} x
 * @param {number} y
 * @param {string|null} texture
 * @param {string=} name
 * @returns {MadnesObject}
 */
MadnesInterface.prototype.addImg = function(x, y, texture, name, phaser) {
    return this.createObject(name).addImg(texture, x, y, phaser);
};

/**
 * @param {string} name
 * @returns {MadnesObject}
 */
MadnesInterface.prototype.setImg = function(name) {
    return this.createObject(name);
};

/**
 * @public
 * @param {string} name
 * @param {string} texture
 * @param {number} x
 * @param {number} y
 * @returns {MadnesObject}
 */
MadnesInterface.prototype.addSprite = function(name, texture, x, y) {
    return this.createObject(name).createSprite(texture, x, y);
};

/**
 * @param {number} x
 * @param {number} y
 * @param {string=} name
 * @returns {MadnesGraphics}
 */
MadnesInterface.prototype.addGraphics = function(x, y, name) {
    return new MadnesGraphics(name).create(x, y);
};

/**
 * @param {string} name
 * @returns {MadnesAudio}
 */
MadnesInterface.prototype.addAudio = function(name) {
    return new MadnesAudio(name);
};

/**
 * @param {string} text
 * @param {number} x
 * @param {number} y
 * @param {Object} style
 * @param {string=} name
 * @returns {MadnesObject}
 */
MadnesInterface.prototype.addText = function(x, y, text, style, name) {
    return this.createObject(name).createText(text, x, y, style);
};

/**
 * @param {string} key
 * @param {number} x
 * @param {number} y
 * @param {string|number} text
 * @param {number=} size
 * @param {string=} name
 * @returns {MadnesObject}
 */
MadnesInterface.prototype.addBitmapText = function(key, x, y, text, size, name) {

    if(typeof size === 'undefined') {
        size = 80;
    }

    return this.createObject(name).createBitmapText(key, x, y, text, size);
};

/**
 * @public
 * @param {string=} name
 * @returns {MadnesGroup}
 */
MadnesInterface.prototype.addGroup = function(name, phaser) {
    return this.createGroup(name, phaser);
};

MadnesInterface.prototype.addTween = function() {
    return new MadnesTween();
};

/**
 * @param {string=} name unique madnes_object name
 * @returns {MadnesObject}
 */
MadnesInterface.prototype.createObject = function(name) {
    return new MadnesObject(name);
};

MadnesInterface.prototype.createTimer = function() {
    return new MadnesTimer();
};

/**
 * @param {string=} name
 * @returns {MadnesGroup}
 */
MadnesInterface.prototype.createGroup = function(name, phaser) {
    return new MadnesGroup(name).create(phaser);
};

/*MadnesInterface.prototype.isInFreeSpins = function() {
	return in_free_spins;
};*/

/**
 * @param {boolean} bool
 * @returns {undefined}
 */
MadnesInterface.prototype.setInFreeSpins = function(bool) {
    set_in_free_spins(bool); //in_free_spins = bool;
};

MadnesInterface.prototype.setWin = function(amount) {
    madnes_set_win(amount);
};

MadnesInterface.prototype.setBigWinFactors = function(big, mega, supermega) {
    madnes_set_win_factors(big, mega, supermega);
};

/**
 * @returns {number}
 */
MadnesInterface.prototype.getBigWinFactor = function() {
    return big_win;
};

/**
 * @param {number} factor
 * @returns {undefined}
 */
MadnesInterface.prototype.setBigWinFactor = function(factor) {
    big_win = factor;
};

/**
 * @returns {number}
 */
MadnesInterface.prototype.getMegaWinFactor = function() {
    return mega_win;
};

/**
 * @param {number} factor
 * @returns {undefined}
 */
MadnesInterface.prototype.setMegaWinFactor = function(factor) {
    mega_win = factor;
};

/**
 * @returns {number}
 */
MadnesInterface.prototype.getSuperMegaWinFactor = function() {
    return super_win;
};

/**
 * @param {number} factor
 * @returns {undefined}
 */
MadnesInterface.prototype.setSuperMegaWinFactor = function(factor) {
    super_win = factor;
};

/**
 * @returns {number} money in real
 */
MadnesInterface.prototype.getWin = function() {
    return win;
};

/*MI.prototype.createAnims = function() {
	return new MadnesAnims();
};*/

MadnesInterface.prototype.getPictureConvert = function() {
    return picture_convert;
};

// MadnesInterface.prototype.setTextureVersion = function(v) {
// 	madnes_set_texture_version(v);
// };

/**
 * @returns {number}
 */
MadnesInterface.prototype.getWi = function() {
    return wi;
};

/**
 * @returns {number}
 */
MadnesInterface.prototype.getHe = function() {
    return he;
};

/**
 * @returns {number}
 */
MadnesInterface.prototype.getMulti = function() {
    return multi;
};

// /**
//  * Sets game dimensions
//  * @param {number} w
//  * @param {number} h
//  */
// MadnesInterface.prototype.setNativeScreenSize = function(w, h) {
// 	madnes_set_native_sceen_size(w, h);
// };

/**
 * Get symbol full name by its index
 * @param {number} symbolNum
 * @returns {string}
 */
MadnesInterface.prototype.getSymbolNameByNum = function(symbolNum) {
    return picture_convert[symbolNum];
};

/**
 * Get symbol full name by reel
 * @param {Array} reel
 * @param {number} x
 * @param {number} y
 * @returns {string}
 */
MadnesInterface.prototype.getSymbolNameFromReel = function(reel, x, y) {
    return this.getSymbolNameByNum(reel[x][y]);
};

/**
 * @param {string} prefix
 * @param {number} start
 * @param {number} stop
 * @param {string} suffix
 * @param {number} zeroPad
 * @returns {Array}
 */
MadnesInterface.prototype.generateFrameNames = function(prefix, start, stop, suffix, zeroPad) {
    return madnes_generate_frame_names(prefix, start, stop, suffix, zeroPad);
};

MadnesInterface.prototype.randomizeFrames = function(frames) {
    var rIdx = getRandomInt(1, frames.length - 2);

    var a1 = frames.slice(0, rIdx);
    var a2 = frames.slice(rIdx, frames.length);

    return a2.concat(a1);
};

MadnesInterface.prototype.getCircleRandInnerPoint = function(x, y, diameter) {
    return madnes_circle_rand_inner_point(x, y, diameter);
};

MadnesInterface.prototype.getCircleRandPoint = function(radius) {
    return madnes_circle_rand_point(radius);
};

MadnesInterface.prototype.keyExists = function(key) {
    return MadnesObject.keyExists(key);
};

/**
 * @param {boolean} bool
 */
MadnesInterface.prototype.setInMoneyAdd = function(bool) {
    set_inmoneyadd(bool ? 1 : 0);
};

/** @returns {boolean} */
MadnesInterface.prototype.inMoneyAdd = function() {
    return !!inmoneyadd;
};

/**
 * @returns {boolean}
 */
MadnesInterface.prototype.inAutoStart = function() {
    return !!inautostart;
};

/**
 * @returns {boolean}
 */
MadnesInterface.prototype.isAutoStartSet = function() {
    return autostart * 1 > 0 || autostart === "∞";
};

MadnesInterface.prototype.endAutoStart = function() {
    // autostart = 0;
};

MadnesInterface.prototype.autoStartDec = function() {
    // if(--autostart < 0) {
    // 	autostart = 0;
    // };
};

MadnesInterface.prototype.getAutoStart = function() {
    // return autostart;
};

/**
 * @param {Function} func
 */
MadnesInterface.prototype.addToRender = function(func) {
    madnes_add_to_render(func);
};

/**
 * @param {Function} func
 */
MadnesInterface.prototype.removeFromRender = function(func) {
    madnes_rem_from_render(func);
};

/**
 * @param {number} intensity
 * @param {number} duration
 */
MadnesInterface.prototype.shakeScreen = function(intensity, duration) {
    madnes_shake_screen(intensity, duration);
};

/**
 * @param {number} x intensity
 * @param {number} y intensity
 * @param {number} duration
 */
MadnesInterface.prototype.shakeScreenXY = function(x, y, duration) {
    madnes_shake_screenXY(x, y, duration);
};

/**
 * @param {string} key
 * @param {string|number} val
 * @param {number=} exdays
 */
MadnesInterface.prototype.setCookie = function(key, val, exdays) {
    // madnes_set_cookie(key, val, exdays);
};

/**
 * @param {string} key
 * @returns {string|undefined}
 */
MadnesInterface.prototype.getCookie = function(key) {
    // return madnes_get_cookie(key);
};


///// MONEY /////

/**
 * @param {number} amount
 */
MadnesInterface.prototype.addMoney = function(amount) {
    // money += amount;
};

/**
 * @param {number} amount
 */
MadnesInterface.prototype.setMoney = function(amount) {
    // money = amount;
};

MadnesInterface.prototype.getMoney = function() {
    return wallet.getBalance();
    // return money * 1;
};

/**
 * @param {number=} addMoney
 * @returns {boolean}
 */
MadnesInterface.prototype.checkMoney = function(addMoney) {
    // return madnes_check_money(addMoney);
};

MadnesInterface.prototype.getMoneyBet = function(b = this.getBet()) {
    return madnes_get_money_bet(b)
};

MadnesInterface.prototype.getAtomicBet = function() {
    return madnes_get_atomic_bet();
};

/**
 * @returns {number} bets in coins
 */
MadnesInterface.prototype.getBet = function() {
    return bet * 1;
};

/**
 * @param {number} m
 * @returns {number}
 */
MadnesInterface.prototype.moneyToCoin = function(m) {
    return madnes_money_to_coin(m);
};

/* ANIMATIONS */

/*MadnesInterface.prototype.animShowMoney = function(amount) {

	return new Promise(function(res) {
		madnes_show_money(amount, res);
	});
};*/